export class CriteriaData {

    codedz : string;
    souszone : string;
    secteur : string;
    localitedd : string;
    pdg : string;
    msisdn : string;
    regroupement : string;
    datedebut: any ;
    datefin: any ;
    horzone:any;
    nature:string;
    produit:string;
    revendeur:string;

    annee:string;
    mois:string;

    constructor() { }
}
